import React, { useState } from 'react';
import RoomContentWrapper, {
  RoomContentWrapperProps,
} from './RoomContentWrapper';
import { useI18n } from '../../../lib/hook/useI18n';
import VideoTracker, { VideoTrackerProps } from '../Tracking/VideoTracker';

export interface RoomVideoContentProps
  extends RoomContentWrapperProps,
    VideoTrackerProps {}

const RoomVideoContent: React.FC<RoomVideoContentProps> = (
  props: RoomVideoContentProps
): JSX.Element => {
  const { cover, disableDefaultCover, rounded, width, ...videoTrackerProps } =
    props;

  const { i18n } = useI18n();
  const [autoPlay, setAutoPlay] = useState(false);

  /** i18n.locale is used as part of the key to unmount the component
   * to initialize a new videojs player with the current language translations
   */
  const key = `${videoTrackerProps.url}-${i18n.locale}`;

  return (
    <RoomContentWrapper
      cover={cover}
      disableDefaultCover={disableDefaultCover}
      key={key}
      rounded={rounded}
      width={width}
      setAutoPlay={setAutoPlay}
    >
      <VideoTracker {...videoTrackerProps} autoPlay={autoPlay} />
    </RoomContentWrapper>
  );
};

export default RoomVideoContent;
